/* unplugin-vue-components disabled */import { render } from "./Logical2DQuestionView.vue?vue&type=template&id=d0334368&scoped=true"
import script from "./Logical2DQuestionView.vue?vue&type=script&lang=js"
export * from "./Logical2DQuestionView.vue?vue&type=script&lang=js"

import "./Logical2DQuestionView.vue?vue&type=style&index=0&id=d0334368&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0334368"]])

export default __exports__